<template>
  <!-- 原型 HTML 还原正文；顶/底由门户 PortalNavbar + PortalFooter 提供 -->
  <div class="sol-ecom-b2b2c">
    <!-- ===== Hero ===== -->
    <section class="hero" id="hero">
      <div class="container">
        <div class="hero-grid">
          <div class="hero-content reveal active">
            <div class="hero-badge">
              <span class="dot"></span>
              <span>已服务 5,000+ 平台型企业 · 30,000+ 入驻商户</span>
            </div>
            <h1>B2B2C多商户商城<br><span class="highlight">平台型电商</span>一站式解决方案</h1>
            <p class="hero-sub">赋能平台运营方整合品牌商、供应商、分销商与终端消费者，构建多方共赢的电商生态。从招商入驻、交易履约到分账结算、数据运营，一个系统支撑全链路平台化经营。</p>
            <div class="hero-tags">
              <span>多商户入驻</span>
              <span>平台自营+POP</span>
              <span>多级分销</span>
              <span>智能分账</span>
              <span>供应链协同</span>
            </div>
            <div class="hero-cta">
              <button class="btn btn-primary btn-lg" @click="scrollToSection('cta')">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                立即预约演示
              </button>
            </div>
            <div class="hero-trust">
              <div class="hero-trust-item">
                <div>
                  <div class="hero-trust-num">5,000+</div>
                  <div class="hero-trust-label">平台客户</div>
                </div>
              </div>
              <div class="hero-trust-divider"></div>
              <div class="hero-trust-item">
                <div>
                  <div class="hero-trust-num">99.95%</div>
                  <div class="hero-trust-label">交易稳定性</div>
                </div>
              </div>
              <div class="hero-trust-divider"></div>
              <div class="hero-trust-item">
                <div>
                  <div class="hero-trust-num">7×24</div>
                  <div class="hero-trust-label">运维保障</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Dashboard Mockup -->
          <div class="hero-visual reveal reveal-delay-1 active">
            <div class="dash-mock">
              <div class="dash-bar">
                <div class="dots"><span></span><span></span><span></span></div>
                <div class="url">b2b2c.zjssoft.com/platform</div>
              </div>
              <div class="dash-body">
                <div class="dash-side">
                  <div class="icon-item active"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="9"/><rect x="14" y="3" width="7" height="5"/><rect x="14" y="12" width="7" height="9"/><rect x="3" y="16" width="7" height="5"/></svg></div>
                  <div class="icon-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 3h18v18H3z"/><path d="M3 9h18M9 21V9"/></svg></div>
                  <div class="icon-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 7L9 18l-5-5"/></svg></div>
                  <div class="icon-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg></div>
                  <div class="icon-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="8" r="4"/><path d="M4 22c0-4 4-7 8-7s8 3 8 7"/></svg></div>
                </div>
                <div class="dash-main">
                  <div class="dash-stats">
                    <div class="dash-stat">
                      <div class="dash-stat-label">今日平台GMV</div>
                      <div class="dash-stat-val">¥1.28M</div>
                      <div class="dash-stat-trend up">↑ 31.2%</div>
                    </div>
                    <div class="dash-stat">
                      <div class="dash-stat-label">入驻商户</div>
                      <div class="dash-stat-val">2,847</div>
                      <div class="dash-stat-trend up">↑ 15.6%</div>
                    </div>
                    <div class="dash-stat">
                      <div class="dash-stat-label">分销订单</div>
                      <div class="dash-stat-val">16,203</div>
                      <div class="dash-stat-trend up">↑ 28.4%</div>
                    </div>
                  </div>
                  <div class="dash-chart">
                    <div class="dash-chart-head">
                      <div class="dash-chart-title">平台交易趋势</div>
                      <div class="dash-chart-tag">近7日</div>
                    </div>
                    <div class="bars">
                      <div class="bar" style="height:45%"></div>
                      <div class="bar" style="height:62%"></div>
                      <div class="bar dim" style="height:38%"></div>
                      <div class="bar" style="height:75%"></div>
                      <div class="bar" style="height:55%"></div>
                      <div class="bar" style="height:88%"></div>
                      <div class="bar" style="height:95%"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="dash-float dash-float-1">
              <div class="dash-float-icon green">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6L9 17l-5-5"/></svg>
              </div>
              <div class="dash-float-text">
                <div class="num">多角色协同</div>
                <div class="label">平台 · 商户 · 分销商</div>
              </div>
            </div>
            <div class="dash-float dash-float-2">
              <div class="dash-float-icon blue">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>
              </div>
              <div class="dash-float-text">
                <div class="num">人效提升 40%</div>
                <div class="label">招商与运营效率</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== Pain Points ===== -->
    <section class="section pain-section" id="pain">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">01 PAIN POINTS</div>
          <h2 class="section-title">平台型电商的经营痛点</h2>
          <p class="section-subtitle">多商户商城涉及平台、商户、分销商、消费者多方角色，传统系统难以支撑复杂的交易、结算与运营协同</p>
        </div>
        <div class="pain-grid">
          <div class="pain-card reveal">
            <div class="pain-num">01</div>
            <div class="pain-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>
            </div>
            <h3 class="pain-title">多角色管理混乱</h3>
            <p class="pain-desc">平台方、入驻商户、分销商、供应商权限边界不清，入驻审核、商品上架、订单履约、售后处理流程不透明，协作效率低下。</p>
          </div>
          <div class="pain-card reveal reveal-delay-1">
            <div class="pain-num">02</div>
            <div class="pain-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
            </div>
            <h3 class="pain-title">交易资金风险高</h3>
            <p class="pain-desc">缺乏合规的分账、结算与资金监管能力，平台二清风险大，商户提现周期长，财务对账繁琐，资金流转不可控。</p>
          </div>
          <div class="pain-card reveal reveal-delay-2">
            <div class="pain-num">03</div>
            <div class="pain-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><path d="M3.27 6.96L12 12.01l8.73-5.05M12 22.08V12"/></svg>
            </div>
            <h3 class="pain-title">供应链协同低效</h3>
            <p class="pain-desc">商品、库存、订单、物流信息分散在多个系统中，平台无法统一调配，超卖、缺货、发货延迟等问题频发。</p>
          </div>
          <div class="pain-card reveal">
            <div class="pain-num">04</div>
            <div class="pain-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
            </div>
            <h3 class="pain-title">营销增长乏力</h3>
            <p class="pain-desc">缺少面向多商户的促销、分销、会员一体化营销工具，流量分发不均，商户活跃度低，用户复购率难以提升。</p>
          </div>
          <div class="pain-card reveal reveal-delay-1">
            <div class="pain-num">05</div>
            <div class="pain-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><path d="M14 2v6h6M16 13H8M16 17H8M10 9H8"/></svg>
            </div>
            <h3 class="pain-title">数据孤岛难决策</h3>
            <p class="pain-desc">交易、用户、商品、营销数据分散，缺少平台级经营视图，无法精准评估商户质量、商品结构与流量转化效率。</p>
          </div>
          <div class="pain-card reveal reveal-delay-2">
            <div class="pain-num">06</div>
            <div class="pain-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
            </div>
            <h3 class="pain-title">技术扩展性差</h3>
            <p class="pain-desc">传统系统架构陈旧，面对大促高并发、多端适配、开放对接等需求时扩展困难，稳定性与安全性难以保障。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== Solution Overview ===== -->
    <section class="section solution-section" id="solution">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">02 SOLUTION OVERVIEW</div>
          <h2 class="section-title">B2B2C 多商户商城方案总览</h2>
          <p class="section-subtitle">以平台运营方为核心，连接供应商、商户、分销商与消费者，构建可管、可控、可持续增长的平台电商生态</p>
        </div>
        <div class="solution-grid">
          <div class="solution-card reveal">
            <div class="solution-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><path d="M9 22V12h6v10"/></svg>
            </div>
            <h3>平台自营 + POP 入驻</h3>
            <p>支持平台自营商品与第三方商户入驻并行运营，灵活配置佣金比例、保证金、类目权限与经营规则，兼顾品牌调性与商品丰富度。</p>
          </div>
          <div class="solution-card reveal reveal-delay-1">
            <div class="solution-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>
            </div>
            <h3>多角色协同中台</h3>
            <p>为平台运营、商户、分销商、供应商、仓配方提供独立工作台，权限分级、流程清晰、数据隔离，保障多方高效协作。</p>
          </div>
          <div class="solution-card reveal reveal-delay-2">
            <div class="solution-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
            </div>
            <h3>合规分账与资金监管</h3>
            <p>基于持牌支付通道与银行存管能力，实现订单分账、自动结算、资金冻结与合规清分，降低平台资金风险。</p>
          </div>
          <div class="solution-card reveal">
            <div class="solution-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/></svg>
            </div>
            <h3>全渠道交易能力</h3>
            <p>覆盖 PC 商城、H5、小程序、APP 及管理后台，统一商品、订单、库存、会员与营销，实现多端一致体验。</p>
          </div>
          <div class="solution-card reveal reveal-delay-1">
            <div class="solution-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>
            </div>
            <h3>智能营销与分销裂变</h3>
            <p>内置拼团、秒杀、优惠券、积分、直播、分销佣金体系，支持平台级活动与商户自营销联动，驱动用户增长与复购。</p>
          </div>
          <div class="solution-card reveal reveal-delay-2">
            <div class="solution-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>
            </div>
            <h3>数据驱动的平台运营</h3>
            <p>提供平台大盘、商户经营、商品分析、用户洞察、营销转化、财务对账多维报表，用数据辅助招商、流量分发与运营决策。</p>
          </div>
        </div>

        <!-- Route -->
        <div class="solution-route reveal active">
          <h3>从招商入驻到生态增长，形成完整业务闭环</h3>
          <div class="route-track">
            <div class="route-item">招商入驻<small>资质审核 · 合同签署</small></div>
            <div class="route-item">商品上架<small>类目管理 · 库存同步</small></div>
            <div class="route-item">交易履约<small>多端下单 · 物流跟踪</small></div>
            <div class="route-item">分账结算<small>自动对账 · 合规提现</small></div>
            <div class="route-item">运营增长<small>流量分发 · 数据复盘</small></div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== Architecture ===== -->
    <section class="section arch-section" id="architecture">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">BUSINESS ARCHITECTURE</div>
          <h2 class="section-title">一张图看懂 B2B2C 业务架构</h2>
          <p class="section-subtitle">以平台中台为核心，打通前端交易、后端履约、资金清分与数据智能，支撑多方角色的协同与增长</p>
        </div>
        <div class="arch-board reveal">
          <div class="arch-kicker"><b>紫金山 AI B2B2C 多商户商城架构</b><span>统一平台 · 多角色协同 · 开放生态</span></div>
          <div class="arch-map">
            <div class="arch-band">
              <div class="arch-band-label">用户触点层<small>覆盖全端购物体验</small></div>
              <div class="arch-band-content">
                <div class="arch-unit"><i>PC</i>PC 商城<small>品牌官网购物</small></div>
                <div class="arch-unit"><i>H5</i>移动商城<small>微信 / 浏览器</small></div>
                <div class="arch-unit"><i>小</i>小程序<small>微信 / 抖音 / 支付宝</small></div>
                <div class="arch-unit"><i>APP</i>商家/用户 APP<small>iOS / Android</small></div>
                <div class="arch-unit"><i>播</i>直播电商<small>带货 / 秒杀</small></div>
                <div class="arch-unit"><i>店</i>智慧门店<small>自提 / 导购</small></div>
              </div>
            </div>
            <div class="arch-band core">
              <div class="arch-band-label">B2B2C 平台中台<small>统一经营核心能力</small></div>
              <div class="arch-band-content">
                <div class="arch-unit"><i>商</i>商品中心<small>SPU / 类目 / 品牌</small></div>
                <div class="arch-unit"><i>订</i>订单中心<small>全渠道聚合</small></div>
                <div class="arch-unit"><i>库</i>库存中心<small>多仓 / 调拨</small></div>
                <div class="arch-unit"><i>账</i>资金中心<small>分账 / 结算</small></div>
                <div class="arch-unit"><i>会</i>会员中心<small>积分 / 等级</small></div>
                <div class="arch-unit"><i>营</i>营销中心<small>促销 / 分销</small></div>
              </div>
            </div>
            <div class="arch-band">
              <div class="arch-band-label">角色工作台<small>多方独立协同</small></div>
              <div class="arch-band-content">
                <div class="arch-unit"><i>平</i>平台运营方<small>招商 / 管控</small></div>
                <div class="arch-unit"><i>商</i>入驻商户<small>店铺 / 商品</small></div>
                <div class="arch-unit"><i>供</i>供应商<small>供货 / 对账</small></div>
                <div class="arch-unit"><i>分</i>分销商<small>推广 / 佣金</small></div>
                <div class="arch-unit"><i>仓</i>仓配服务商<small>发货 / 退换</small></div>
                <div class="arch-unit"><i>客</i>消费者<small>下单 / 售后</small></div>
              </div>
            </div>
            <div class="arch-band">
              <div class="arch-band-label">数据与生态能力<small>驱动增长与连接</small></div>
              <div class="arch-band-content">
                <div class="arch-unit"><i>数</i>经营驾驶舱<small>实时大盘</small></div>
                <div class="arch-unit"><i>AI</i>智能推荐<small>千人千面</small></div>
                <div class="arch-unit"><i>API</i>开放接口<small>ERP / 支付 / 物流</small></div>
                <div class="arch-unit"><i>安</i>安全合规<small>审计 / 风控</small></div>
                <div class="arch-unit"><i>移</i>数据迁移<small>历史数据导入</small></div>
                <div class="arch-unit"><i>运</i>运维监控<small>7×24 保障</small></div>
              </div>
            </div>
          </div>
          <div class="arch-map-note">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/></svg>
            架构可按业务规模灵活裁剪，支持 SaaS 订阅与私有化部署两种交付模式
          </div>
        </div>
      </div>
    </section>

    <!-- ===== Core Functions ===== -->
    <section class="section func-section" id="features">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">03 CORE FUNCTIONS</div>
          <h2 class="section-title">8 大核心功能模块</h2>
          <p class="section-subtitle">覆盖平台运营、商户经营、交易履约、资金清分与营销增长全链路，满足多商户商城复杂业务场景</p>
        </div>
        <div class="func-grid">
          <div class="func-card reveal">
            <div class="func-card-num">01</div>
            <div class="func-card-body">
              <div class="func-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>
              </div>
              <h3>商户入驻与店铺管理</h3>
              <p>在线提交资质、平台审核、合同签署、保证金缴纳、店铺装修一站式完成，支持多店铺、多类目与经营状态管控。</p>
            </div>
          </div>
          <div class="func-card reveal reveal-delay-1">
            <div class="func-card-num">02</div>
            <div class="func-card-body">
              <div class="func-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/></svg>
              </div>
              <h3>商品与供应链中心</h3>
              <p>支持平台统一商品库与商户自主上架，SKU / SPU 标准化管理，价格监控、库存同步、供应链协同全程可控。</p>
            </div>
          </div>
          <div class="func-card reveal reveal-delay-2">
            <div class="func-card-num">03</div>
            <div class="func-card-body">
              <div class="func-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 3h18v18H3z"/><path d="M3 9h18M9 21V9"/></svg>
              </div>
              <h3>全渠道订单履约</h3>
              <p>聚合多端订单，智能拆单、就近发货、门店自提、快递配送、电子面单全链路覆盖，支持平台售后仲裁。</p>
            </div>
          </div>
          <div class="func-card reveal reveal-delay-3">
            <div class="func-card-num">04</div>
            <div class="func-card-body">
              <div class="func-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
              </div>
              <h3>智能分账与财务结算</h3>
              <p>按订单自动拆分平台佣金、商户货款、分销佣金与物流费用，支持 T+1 / T+7 结算周期，资金合规可审计。</p>
            </div>
          </div>
          <div class="func-card reveal">
            <div class="func-card-num">05</div>
            <div class="func-card-body">
              <div class="func-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>
              </div>
              <h3>平台级与商户级营销</h3>
              <p>拼团、秒杀、满减、优惠券、积分商城、会员日等平台活动与商户自营销灵活组合，统一规则与流量入口。</p>
            </div>
          </div>
          <div class="func-card reveal reveal-delay-1">
            <div class="func-card-num">06</div>
            <div class="func-card-body">
              <div class="func-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>
              </div>
              <h3>会员与分销体系</h3>
              <p>统一会员等级、积分、权益与标签，支持多级分销、邀请返利、团长裂变，让流量在平台生态内持续流转。</p>
            </div>
          </div>
          <div class="func-card reveal reveal-delay-2">
            <div class="func-card-num">07</div>
            <div class="func-card-body">
              <div class="func-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
              </div>
              <h3>平台运营管控中心</h3>
              <p>商品审核、价格监控、违规处理、评价管理、广告位配置、流量分发与平台公告，保障平台健康有序运营。</p>
            </div>
          </div>
          <div class="func-card reveal reveal-delay-3">
            <div class="func-card-num">08</div>
            <div class="func-card-body">
              <div class="func-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><path d="M14 2v6h6M16 13H8M16 17H8M10 9H8"/></svg>
              </div>
              <h3>数据报表与经营分析</h3>
              <p>平台大盘、商户经营、商品分析、用户画像、营销转化、财务对账多维报表，支持自定义导出与订阅推送。</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== Core Advantages ===== -->
    <section class="section advantage-section" id="advantage">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">04 CORE ADVANTAGES</div>
          <h2 class="section-title">为什么选择紫金山 AI B2B2C 商城</h2>
          <p class="section-subtitle">沉淀多年平台型电商经验，从业务理解、技术架构到服务落地，全方位保障平台快速上线与持续运营</p>
        </div>
        <div class="advantage-grid">
          <div class="advantage-card reveal">
            <div class="advantage-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><path d="M22 4L12 14.01l-3-3"/></svg>
            </div>
            <h3>成熟稳定的平台架构</h3>
            <p>微服务 + 云原生架构，支持高并发大促场景，系统可用性达 99.95%，已验证承载亿级交易规模。</p>
          </div>
          <div class="advantage-card reveal reveal-delay-1">
            <div class="advantage-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="9" y1="21" x2="9" y2="9"/></svg>
            </div>
            <h3>开箱即用的行业模板</h3>
            <p>提供综合电商、垂直品类、生鲜农贸、工业品集采等行业模板，配置化上线，缩短项目交付周期。</p>
          </div>
          <div class="advantage-card reveal reveal-delay-2">
            <div class="advantage-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
            </div>
            <h3>合规清分降低资金风险</h3>
            <p>对接持牌支付与银行存管，订单资金按规则自动分账，规避二清风险，满足平台型电商合规要求。</p>
          </div>
          <div class="advantage-card reveal reveal-delay-3">
            <div class="advantage-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>
            </div>
            <h3>灵活多变的商业模式</h3>
            <p>支持平台自营、POP 入驻、供应链代发、社交电商、社区团购、企业集采等多种模式自由组合。</p>
          </div>
          <div class="advantage-card reveal">
            <div class="advantage-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
            </div>
            <h3>持续迭代的产品能力</h3>
            <p>紧跟电商趋势，持续更新直播带货、短视频种草、AI 客服、智能推荐等功能，保持平台竞争力。</p>
          </div>
          <div class="advantage-card reveal reveal-delay-1">
            <div class="advantage-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.66 0 3-4.03 3-9s-1.34-9-3-9m0 18c-1.66 0-3-4.03-3-9s1.34-9 3-9m-9 9a9 9 0 019-9"/></svg>
            </div>
            <h3>多端一体化体验</h3>
            <p>一套后台管理 PC 商城、H5、小程序、APP 与商户后台，数据互通，体验一致，降低多端维护成本。</p>
          </div>
          <div class="advantage-card reveal reveal-delay-2">
            <div class="advantage-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><path d="M14 2v6h6M16 13H8M16 17H8M10 9H8"/></svg>
            </div>
            <h3>开放集成与定制扩展</h3>
            <p>提供标准化 API 与 webhook，支持与 ERP、WMS、CRM、财务系统及第三方物流、支付平台快速对接。</p>
          </div>
          <div class="advantage-card reveal reveal-delay-3">
            <div class="advantage-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
            </div>
            <h3>全周期客户成功服务</h3>
            <p>从业务诊断、方案设计、系统上线到运营陪跑，专属顾问团队提供 7×24 小时技术支持与持续优化建议。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== Application Scenarios ===== -->
    <section class="section scenario-section" id="scenario">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">05 APPLICATION SCENARIOS</div>
          <h2 class="section-title">典型应用场景</h2>
          <p class="section-subtitle">不同行业、不同规模的平台型电商，都能找到适配的 B2B2C 商城解决方案</p>
        </div>
        <div class="scenario-grid">
          <div class="scenario-card reveal">
            <span class="scenario-tag">综合电商平台</span>
            <h3>多品类综合商城</h3>
            <p>平台整合多行业品牌商与经销商，提供统一的交易、物流、售后与营销服务，打造区域化或垂直化综合电商平台。</p>
          </div>
          <div class="scenario-card reveal reveal-delay-1">
            <span class="scenario-tag">品牌供应链平台</span>
            <h3>品牌方渠道分销平台</h3>
            <p>品牌总部搭建 B2B2C 平台，管理直营、经销商、分销商与终端消费者，统一价格政策与库存调配。</p>
          </div>
          <div class="scenario-card reveal reveal-delay-2">
            <span class="scenario-tag">生鲜农贸</span>
            <h3>农产品上行平台</h3>
            <p>连接产地供应商、批发商、社区团购团长与消费者，支持预售、产地直发、同城配送与团长分佣。</p>
          </div>
          <div class="scenario-card reveal">
            <span class="scenario-tag">工业品采购</span>
            <h3>MRO 工业品集采平台</h3>
            <p>面向企业客户的工业品集采平台，支持多供应商入驻、企业账期、审批流程与多组织架构采购。</p>
          </div>
          <div class="scenario-card reveal reveal-delay-1">
            <span class="scenario-tag">社交电商</span>
            <h3>分销裂变型商城</h3>
            <p>以社交裂变为核心，支持多级分销、团长、达人带货与佣金自动结算，快速放大平台流量与销量。</p>
          </div>
          <div class="scenario-card reveal reveal-delay-2">
            <span class="scenario-tag">本地生活</span>
            <h3>本地服务+零售平台</h3>
            <p>整合本地餐饮、零售、服务商户，支持到店、到家、自提多种履约方式，构建本地生活服务平台。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== Customer Value ===== -->
    <section class="section value-section" id="value">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">06 CUSTOMER VALUE</div>
          <h2 class="section-title">为客户创造的真实价值</h2>
          <p class="section-subtitle">从平台运营方、入驻商户到终端消费者，每一方都能在 B2B2C 商城中获得可量化的收益</p>
        </div>
        <div class="value-grid">
          <div class="value-card reveal">
            <div class="value-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 1v22M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg>
            </div>
            <h3>平台运营方</h3>
            <p>统一招商、交易与结算，提升平台管控力，降低资金与合规风险，通过流量分发与增值服务实现多元化盈利。</p>
            <span class="value-highlight">综合收益提升 35%+</span>
          </div>
          <div class="value-card reveal reveal-delay-1">
            <div class="value-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 3h18v18H3z"/><path d="M3 9h18M9 21V9"/></svg>
            </div>
            <h3>入驻商户</h3>
            <p>低门槛入驻平台，共享平台流量与营销工具，专注商品与服务，借助平台履约能力快速扩大销售规模。</p>
            <span class="value-highlight">获客成本降低 40%</span>
          </div>
          <div class="value-card reveal reveal-delay-2">
            <div class="value-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>
            </div>
            <h3>分销商 / 团长</h3>
            <p>一键选品、智能分佣、实时提现，借助社交关系与内容传播获得稳定收益，推动平台商品快速触达终端。</p>
            <span class="value-highlight">分销效率提升 50%</span>
          </div>
          <div class="value-card reveal reveal-delay-3">
            <div class="value-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>
            </div>
            <h3>终端消费者</h3>
            <p>享受丰富的商品选择、优惠的促销活动、便捷的下单履约与统一的售后服务，购物体验更省心、更放心。</p>
            <span class="value-highlight">复购率提升 28%</span>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== Trust Section ===== -->
    <section class="section trust-section" id="trust">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">TRUST &amp; CERTIFICATION</div>
          <h2 class="section-title">值得信赖的平台型电商伙伴</h2>
          <p class="section-subtitle">紫金山 AI 深耕电商 SaaS 领域多年，以技术实力与服务口碑赢得众多平台客户信赖</p>
        </div>
        <div class="trust-stats reveal">
          <div class="trust-stat">
            <div class="num">5,000<span class="unit">+</span></div>
            <div class="label">平台型企业客户</div>
          </div>
          <div class="trust-stat">
            <div class="num">30,000<span class="unit">+</span></div>
            <div class="label">累计入驻商户</div>
          </div>
          <div class="trust-stat">
            <div class="num">99.95<span class="unit">%</span></div>
            <div class="label">交易系统可用性</div>
          </div>
          <div class="trust-stat">
            <div class="num">7×24</div>
            <div class="label">运维服务保障</div>
          </div>
        </div>
        <div class="logo-wall reveal">
          <div class="logo-wall-title">服务客户覆盖多个行业领域</div>
          <div class="logo-grid">
            <div class="logo-item">综合电商</div>
            <div class="logo-item">生鲜农贸</div>
            <div class="logo-item">工业品采购</div>
            <div class="logo-item">母婴用品</div>
            <div class="logo-item">家居建材</div>
            <div class="logo-item">美妆个护</div>
            <div class="logo-item">数码家电</div>
            <div class="logo-item">食品饮料</div>
            <div class="logo-item">本地生活</div>
            <div class="logo-item">跨境贸易</div>
            <div class="logo-item">服装鞋包</div>
            <div class="logo-item">医药健康</div>
          </div>
        </div>
        <div class="trust-cert reveal">
          <div class="cert-card">
            <div class="cert-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><path d="M22 4L12 14.01l-3-3"/></svg>
            </div>
            <div class="cert-info">
              <div class="title">国家高新技术企业认证</div>
              <div class="desc">持续投入电商底层技术与 AI 应用研发</div>
            </div>
          </div>
          <div class="cert-card">
            <div class="cert-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
            </div>
            <div class="cert-info">
              <div class="title">等保三级安全认证</div>
              <div class="desc">保障平台交易与数据安全合规</div>
            </div>
          </div>
          <div class="cert-card">
            <div class="cert-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"/><path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"/></svg>
            </div>
            <div class="cert-info">
              <div class="title">软件著作权与专利</div>
              <div class="desc">拥有多项电商中台核心自主知识产权</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== FAQ ===== -->
    <section class="section faq-section" id="faq">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">07 FAQ</div>
          <h2 class="section-title">常见问题解答</h2>
          <p class="section-subtitle">关于 B2B2C 多商户商城方案的常见疑问，我们为您一一解答</p>
        </div>
        <div class="faq-wrap reveal">
          <div class="faq-item">
            <div class="faq-q">
              <span>B2B2C 商城与单商户商城有什么区别？</span>
              <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>
            </div>
            <div class="faq-a">
              <div class="faq-a-inner">单商户商城仅由平台自身销售商品，而 B2B2C 商城支持平台自营与第三方商户入驻并行，涉及平台、商户、供应商、分销商、消费者多方角色，需要更复杂的权限管理、资金清分与运营协同能力。</div>
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-q">
              <span>平台如何规避二清资金风险？</span>
              <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>
            </div>
            <div class="faq-a">
              <div class="faq-a-inner">紫金山 AI B2B2C 商城对接持牌支付机构与银行存管账户，订单资金直接进入监管账户，系统按预设规则自动分账给平台、商户、分销商与物流方，确保资金流转合规透明。</div>
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-q">
              <span>支持哪些终端和部署方式？</span>
              <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>
            </div>
            <div class="faq-a">
              <div class="faq-a-inner">支持 PC 商城、H5、微信小程序、支付宝小程序、抖音小程序、iOS / Android APP 以及商户管理后台。部署方式可选择 SaaS 云端订阅或私有化独立部署，满足不同规模与安全要求。</div>
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-q">
              <span>是否支持与现有 ERP / WMS 对接？</span>
              <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>
            </div>
            <div class="faq-a">
              <div class="faq-a-inner">支持。我们提供标准化 Open API、Webhook 与数据导入导出工具，可与主流 ERP、WMS、财务系统、CRM、OMS、第三方物流与支付平台快速集成，降低系统切换成本。</div>
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-q">
              <span>上线周期大概需要多久？</span>
              <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>
            </div>
            <div class="faq-a">
              <div class="faq-a-inner">基于成熟行业模板与配置化能力，标准版 B2B2C 商城通常 2-4 周可完成上线；涉及复杂定制、多系统对接或大规模商户迁移的项目，我们会根据需求提供专属实施计划。</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== Final CTA ===== -->
    <section class="cta-section" id="cta">
      <div class="container">
        <div class="cta-inner reveal active">
          <h2>开启您的 <span class="highlight">B2B2C 平台电商</span> 之旅</h2>
          <p>无论您是计划打造综合电商平台、品牌分销网络，还是区域产业带商城，紫金山 AI 都能为您提供成熟可靠的解决方案与落地服务。</p>
          <div class="cta-options">
            <a class="btn btn-primary btn-lg" href="#" role="button" @click.prevent="openCustomerService">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
              咨询详情
            </a>
          </div>
          <div class="cta-note">
            <span class="dot"></span>
            <span>7×24 小时技术响应</span>
            <span class="dot"></span>
            <span>免费业务诊断</span>
            <span class="dot"></span>
            <span>专属实施顾问</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts" setup>
import { openCustomerService } from '../../openCustomerService'
defineOptions({ name: 'PortalEcomB2b2c' })

let revealIo: IntersectionObserver | null = null

function scrollToSection(id: string) {
  const el = document.getElementById(id)
  if (!el) return
  const scroller = document.querySelector('.portal-page') as HTMLElement | null
  if (scroller) {
    const top =
      el.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop - 12
    scroller.scrollTo({ top, behavior: 'smooth' })
    return
  }
  window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 72, behavior: 'smooth' })
}

function bindFaq() {
  const rootEl = document.querySelector('.sol-ecom-b2b2c')
  if (!rootEl) return
  rootEl.querySelectorAll('.faq-item').forEach((item) => {
    const q = item.querySelector('.faq-q') as HTMLElement | null
    const a = item.querySelector('.faq-a') as HTMLElement | null
    if (!q || !a) return
    a.style.maxHeight = '0'
    q.onclick = () => {
      const isActive = item.classList.contains('active')
      rootEl.querySelectorAll('.faq-item').forEach((other) => {
        other.classList.remove('active')
        const oa = other.querySelector('.faq-a') as HTMLElement | null
        if (oa) oa.style.maxHeight = '0'
      })
      if (!isActive) {
        item.classList.add('active')
        a.style.maxHeight = a.scrollHeight + 'px'
      }
    }
  })
}

function bindReveal() {
  const nodes = document.querySelectorAll('.sol-ecom-b2b2c .reveal')
  revealIo = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) entry.target.classList.add('active')
      })
    },
    { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
  )
  nodes.forEach((n) => revealIo!.observe(n))
}

function bindBars() {
  const bars = document.querySelectorAll('.sol-ecom-b2b2c .bars .bar')
  bars.forEach((bar, i) => {
    const el = bar as HTMLElement
    const h = el.style.height
    if (!h) return
    el.style.height = '0'
    window.setTimeout(() => {
      el.style.transition = `height .8s ease ${i * 0.08}s`
      el.style.height = h
    }, 100)
  })
}

onMounted(() => {
  bindFaq()
  bindReveal()
  bindBars()
})

onBeforeUnmount(() => {
  revealIo?.disconnect()
  revealIo = null
})
</script>

<style lang="scss">

/* ===== Reset & Base ===== */
.sol-ecom-b2b2c,.sol-ecom-b2b2c *,.sol-ecom-b2b2c *::before,.sol-ecom-b2b2c *::after{margin:0;padding:0;box-sizing:border-box}
.sol-ecom-b2b2c{
  --c-primary:#1e88e5;
  --c-primary-2:#1976d2;
  --c-primary-3:#1565c0;
  --c-primary-4:#0d47a1;
  --c-primary-light:#42a5f5;
  --c-primary-bright:#2196f3;
  --c-cyan:#06b6d4;
  --c-slate:#475569;
  --c-slate-light:#64748b;
  --c-text:#0f172a;
  --c-text-mid:#334155;
  --c-bg:#f5f9ff;
  --c-bg-2:#eef4fc;
  --c-bg-3:#e8f1fb;
  --c-border:#e2e8f0;
  --c-white:#fff;
  --radius:14px;
  --radius-lg:22px;
  --shadow-sm:0 2px 8px rgba(30,136,229,.08);
  --shadow:0 8px 28px rgba(30,136,229,.10);
  --shadow-lg:0 18px 56px rgba(30,136,229,.14);
  --shadow-xl:0 28px 80px rgba(30,136,229,.18);
  --max-w:1280px;
  --font:-apple-system,BlinkMacSystemFont,"Segoe UI","PingFang SC","Hiragino Sans GB","Microsoft YaHei",sans-serif;
}
.sol-ecom-b2b2c{scroll-behavior:smooth;font-size:16px}
.sol-ecom-b2b2c{font-family:var(--font);color:var(--c-text);background:var(--c-white);line-height:1.7;overflow-x:hidden;-webkit-font-smoothing:antialiased}
.sol-ecom-b2b2c a{text-decoration:none;color:inherit}
.sol-ecom-b2b2c img{max-width:100%;display:block}
.sol-ecom-b2b2c ul{list-style:none}
.sol-ecom-b2b2c .container{max-width:var(--max-w);margin:0 auto;padding:0 24px}
.sol-ecom-b2b2c .section{padding:96px 0;position:relative}
.sol-ecom-b2b2c .section-sm{padding:72px 0}

/* ===== Typography ===== */
.sol-ecom-b2b2c .section-num{display:none}
.sol-ecom-b2b2c .section-title{font-size:2.4rem;font-weight:800;color:var(--c-text);line-height:1.25;margin-bottom:18px;letter-spacing:-.02em}
.sol-ecom-b2b2c .section-subtitle{font-size:1.08rem;color:var(--c-slate);max-width:720px;line-height:1.8}
.sol-ecom-b2b2c .section-head{margin-bottom:46px}
.sol-ecom-b2b2c .section-head.center{text-align:center}
.sol-ecom-b2b2c .section-head.center .section-subtitle{margin:0 auto}

/* ===== Buttons ===== */
.sol-ecom-b2b2c .btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;padding:12px 28px;border-radius:12px;font-size:.94rem;font-weight:600;cursor:pointer;border:none;transition:all .25s;white-space:nowrap;line-height:1.2}
.sol-ecom-b2b2c .btn-primary{background:#1e88e5;color:#fff;box-shadow:0 4px 14px rgba(30,136,229,.35)}
.sol-ecom-b2b2c .btn-primary:hover{transform:translateY(-2px);box-shadow:0 6px 18px rgba(30,136,229,.45)}
.sol-ecom-b2b2c .btn-primary:active{transform:translateY(1px)}
.sol-ecom-b2b2c .btn-ghost{background:rgba(255,255,255,.14);color:#fff;border:1px solid rgba(255,255,255,.35);backdrop-filter:blur(6px)}
.sol-ecom-b2b2c .btn-ghost:hover{background:rgba(255,255,255,.24);transform:translateY(-2px)}
.sol-ecom-b2b2c .btn-lg{padding:17px 40px;font-size:1.05rem;border-radius:14px}

/* ===== Hero ===== */
.sol-ecom-b2b2c .hero{position:relative;background:#0d47a1;padding:88px 0 100px;overflow:hidden}
.sol-ecom-b2b2c .hero-grid{display:grid;grid-template-columns:1.1fr .9fr;gap:56px;align-items:center;position:relative;z-index:1}
.sol-ecom-b2b2c .hero-badge{display:inline-flex;align-items:center;gap:10px;padding:8px 18px;background:rgba(255,255,255,.12);border:1px solid rgba(255,255,255,.25);border-radius:100px;color:#fff;font-size:.82rem;font-weight:500;margin-bottom:30px;backdrop-filter:blur(8px)}
.sol-ecom-b2b2c .hero-badge .dot{width:8px;height:8px;background:#34d399;border-radius:50%;box-shadow:0 0 10px #34d399;animation:pulse 1.6s ease-in-out infinite}
@keyframes pulse{0%,100%{opacity:1;transform:scale(1)}50%{opacity:.6;transform:scale(1.3)}}
.sol-ecom-b2b2c .hero h1{font-size:3.2rem;font-weight:900;color:#fff;line-height:1.18;letter-spacing:-.025em;margin-bottom:24px}
.sol-ecom-b2b2c .hero h1 .highlight{color:#bbdefb;position:relative;display:inline-block}
.sol-ecom-b2b2c .hero-sub{font-size:1.14rem;color:rgba(255,255,255,.85);line-height:1.85;margin-bottom:28px;max-width:560px}
.sol-ecom-b2b2c .hero-tags{display:flex;flex-wrap:wrap;gap:10px;margin-bottom:36px}
.sol-ecom-b2b2c .hero-tags span{padding:7px 16px;border:1px solid rgba(255,255,255,.3);border-radius:30px;font-size:.8rem;color:rgba(255,255,255,.85);background:rgba(255,255,255,.06);backdrop-filter:blur(4px)}
.sol-ecom-b2b2c .hero-cta{display:flex;gap:16px;margin-bottom:40px;flex-wrap:wrap}
.sol-ecom-b2b2c .hero-trust{display:flex;align-items:center;gap:30px;flex-wrap:wrap}
.sol-ecom-b2b2c .hero-trust-item{display:flex;align-items:center;gap:10px}
.sol-ecom-b2b2c .hero-trust-num{font-size:1.65rem;font-weight:800;color:#fff}
.sol-ecom-b2b2c .hero-trust-label{font-size:.82rem;color:rgba(255,255,255,.6)}
.sol-ecom-b2b2c .hero-trust-divider{width:1px;height:40px;background:rgba(255,255,255,.18)}

/* Hero Dashboard Mockup */
.sol-ecom-b2b2c .hero-visual{position:relative}
.sol-ecom-b2b2c .dash-mock{background:#fff;border-radius:18px;box-shadow:0 40px 90px rgba(0,30,80,.45);overflow:hidden;border:1px solid rgba(255,255,255,.2)}
.sol-ecom-b2b2c .dash-bar{display:flex;align-items:center;gap:8px;padding:14px 18px;background:#f0f7ff;border-bottom:1px solid var(--c-border)}
.sol-ecom-b2b2c .dash-bar .dots{display:flex;gap:6px}
.sol-ecom-b2b2c .dash-bar .dots span{width:10px;height:10px;border-radius:50%}
.sol-ecom-b2b2c .dash-bar .dots span:nth-child(1){background:#ef4444}
.sol-ecom-b2b2c .dash-bar .dots span:nth-child(2){background:#f59e0b}
.sol-ecom-b2b2c .dash-bar .dots span:nth-child(3){background:#22c55e}
.sol-ecom-b2b2c .dash-bar .url{flex:1;text-align:center;font-size:.72rem;color:var(--c-slate-light);background:#fff;border:1px solid var(--c-border);border-radius:6px;padding:4px 14px;margin-left:8px}
.sol-ecom-b2b2c .dash-body{display:grid;grid-template-columns:68px 1fr;min-height:360px}
.sol-ecom-b2b2c .dash-side{background:#1565c0;padding:16px 0;display:flex;flex-direction:column;align-items:center;gap:16px}
.sol-ecom-b2b2c .dash-side .icon-item{width:40px;height:40px;border-radius:10px;display:flex;align-items:center;justify-content:center;color:rgba(255,255,255,.5);transition:.2s}
.sol-ecom-b2b2c .dash-side .icon-item.active{background:#1e88e5;color:#fff;box-shadow:0 4px 12px rgba(30,136,229,.5)}
.sol-ecom-b2b2c .dash-side .icon-item svg{width:18px;height:18px}
.sol-ecom-b2b2c .dash-main{padding:20px;background:#fafbfc}
.sol-ecom-b2b2c .dash-stats{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin-bottom:16px}
.sol-ecom-b2b2c .dash-stat{background:#fff;border:1px solid var(--c-border);border-radius:12px;padding:14px;transition:.2s}
.sol-ecom-b2b2c .dash-stat:hover{border-color:var(--c-primary-light);box-shadow:0 4px 12px rgba(30,136,229,.1)}
.sol-ecom-b2b2c .dash-stat-label{font-size:.68rem;color:var(--c-slate-light);margin-bottom:4px}
.sol-ecom-b2b2c .dash-stat-val{font-size:1.2rem;font-weight:800;color:var(--c-text)}
.sol-ecom-b2b2c .dash-stat-trend{font-size:.65rem;font-weight:700;margin-top:3px}
.sol-ecom-b2b2c .up{color:#10b981}
.sol-ecom-b2b2c .dn{color:#ef4444}
.sol-ecom-b2b2c .dash-chart{background:#fff;border:1px solid var(--c-border);border-radius:12px;padding:16px}
.sol-ecom-b2b2c .dash-chart-head{display:flex;justify-content:space-between;align-items:center;margin-bottom:14px}
.sol-ecom-b2b2c .dash-chart-title{font-size:.74rem;font-weight:600;color:var(--c-text)}
.sol-ecom-b2b2c .dash-chart-tag{font-size:.62rem;color:var(--c-primary);background:#e6f1ff;padding:3px 10px;border-radius:100px;font-weight:600}
.sol-ecom-b2b2c .bars{display:flex;align-items:flex-end;gap:6px;height:96px}
.sol-ecom-b2b2c .bar{flex:1;border-radius:4px 4px 0 0;background:#1e88e5;opacity:.9;transition:opacity .2s}
.sol-ecom-b2b2c .bar:hover{opacity:1}
.sol-ecom-b2b2c .bar.dim{background:#94a3b8}
.sol-ecom-b2b2c .dash-float{position:absolute;background:#fff;border-radius:14px;box-shadow:0 14px 36px rgba(0,30,80,.25);padding:14px 18px;display:flex;align-items:center;gap:14px;animation:float 3.5s ease-in-out infinite;border:1px solid rgba(255,255,255,.6)}
.sol-ecom-b2b2c .dash-float-1{top:-20px;right:-12px;animation-delay:0s}
.sol-ecom-b2b2c .dash-float-2{bottom:-18px;left:-18px;animation-delay:1.5s}
.sol-ecom-b2b2c .dash-float-icon{width:42px;height:42px;border-radius:12px;display:flex;align-items:center;justify-content:center;flex-shrink:0}
.sol-ecom-b2b2c .dash-float-icon.green{background:linear-gradient(135deg,#d1fae5,#a7f3d0);color:#10b981}
.sol-ecom-b2b2c .dash-float-icon.blue{background:linear-gradient(135deg,#dbeafe,#bfdbfe);color:#1e88e5}
.sol-ecom-b2b2c .dash-float-text .num{font-size:1.05rem;font-weight:800;color:var(--c-text)}
.sol-ecom-b2b2c .dash-float-text .label{font-size:.7rem;color:var(--c-slate-light)}
@keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-12px)}}

/* ===== Pain Points ===== */
.sol-ecom-b2b2c .pain-section{background:#f5f9ff}
.sol-ecom-b2b2c .pain-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:28px}
.sol-ecom-b2b2c .pain-card{background:#fff;border:1px solid var(--c-border);border-radius:var(--radius-lg);padding:36px 30px;transition:all .3s;position:relative;overflow:hidden}
.sol-ecom-b2b2c .pain-card:hover{border-color:var(--c-primary-light);box-shadow:var(--shadow-xl);transform:translateY(-6px)}
.sol-ecom-b2b2c .pain-card::before{content:"";position:absolute;top:0;left:0;right:0;height:4px;background:#1e88e5;transform:scaleX(0);transform-origin:left;transition:transform .4s}
.sol-ecom-b2b2c .pain-card:hover::before{transform:scaleX(1)}
.sol-ecom-b2b2c .pain-num{position:absolute;top:24px;right:28px;font-size:2.8rem;font-weight:900;color:rgba(30,136,229,.06);line-height:1}
.sol-ecom-b2b2c .pain-icon{width:56px;height:56px;border-radius:14px;background:#e3f2fd;display:flex;align-items:center;justify-content:center;margin-bottom:22px;box-shadow:0 8px 20px rgba(30,136,229,.15)}
.sol-ecom-b2b2c .pain-icon svg{width:28px;height:28px;color:var(--c-primary-2)}
.sol-ecom-b2b2c .pain-title{font-size:1.2rem;font-weight:700;color:var(--c-text);margin-bottom:12px}
.sol-ecom-b2b2c .pain-desc{font-size:.92rem;color:var(--c-slate);line-height:1.8}

/* ===== Solution Overview ===== */
.sol-ecom-b2b2c .solution-section{background:#fff}
.sol-ecom-b2b2c .solution-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:28px}
.sol-ecom-b2b2c .solution-card{background:#fff;border:1px solid var(--c-border);border-radius:var(--radius-lg);padding:40px 32px;transition:all .3s;position:relative;overflow:hidden}
.sol-ecom-b2b2c .solution-card:hover{box-shadow:var(--shadow-lg);transform:translateY(-4px)}
.sol-ecom-b2b2c .solution-icon{width:52px;height:52px;border-radius:12px;background:#1e88e5;display:flex;align-items:center;justify-content:center;margin-bottom:22px;box-shadow:0 8px 20px rgba(30,136,229,.3)}
.sol-ecom-b2b2c .solution-icon svg{width:26px;height:26px;color:#fff}
.sol-ecom-b2b2c .solution-card h3{font-size:1.25rem;font-weight:700;color:var(--c-text);margin-bottom:14px}
.sol-ecom-b2b2c .solution-card p{font-size:.95rem;color:var(--c-slate);line-height:1.8}

/* ===== Solution Route ===== */
.sol-ecom-b2b2c .solution-route{margin-top:34px;padding:26px;background:#fff;border:1px solid #dce7f3;border-radius:16px;box-shadow:var(--shadow-sm)}
.sol-ecom-b2b2c .solution-route h3{text-align:center;font-size:1.12rem;margin-bottom:22px;color:var(--c-text)}
.sol-ecom-b2b2c .route-track{display:grid;grid-template-columns:repeat(5,1fr);gap:12px;position:relative}
.sol-ecom-b2b2c .route-item{position:relative;text-align:center;padding:15px 8px;background:#f4f8fe;border:1px solid #d7e7f9;border-radius:10px;font-size:.84rem;font-weight:700;color:#174f8b}
.sol-ecom-b2b2c .route-item small{display:block;margin-top:5px;color:#6c829b;font-size:.68rem;font-weight:400}
.sol-ecom-b2b2c .route-item:not(:last-child):after{content:'→';position:absolute;right:-12px;top:30px;color:#087cf0;font-size:18px;z-index:2}

/* ===== Architecture ===== */
.sol-ecom-b2b2c .arch-section{background:#f5f9ff}
.sol-ecom-b2b2c .arch-board{padding:34px;border:1px solid #d5e6f8;border-radius:20px;background:#f8fbff;box-shadow:0 16px 36px rgba(13,71,161,.08);position:relative}
.sol-ecom-b2b2c .arch-kicker{display:flex;justify-content:space-between;align-items:center;position:relative;margin-bottom:20px}
.sol-ecom-b2b2c .arch-kicker b{font-size:1.1rem;color:#102e52}
.sol-ecom-b2b2c .arch-kicker span{font-size:.78rem;color:var(--c-primary-3);background:#e6f2ff;border-radius:100px;padding:6px 12px}
.sol-ecom-b2b2c .arch-map{display:grid;gap:13px}
.sol-ecom-b2b2c .arch-band{display:grid;grid-template-columns:174px 1fr;gap:13px;align-items:stretch}
.sol-ecom-b2b2c .arch-band-label{padding:16px;border-radius:12px;display:flex;flex-direction:column;justify-content:center;background:#e6f1ff;color:#125aa5;font-size:.92rem;font-weight:800}
.sol-ecom-b2b2c .arch-band-label small{margin-top:5px;color:#5f87b4;font-size:.68rem;font-weight:500}
.sol-ecom-b2b2c .arch-band-content{display:grid;grid-template-columns:repeat(6,minmax(0,1fr));gap:10px}
.sol-ecom-b2b2c .arch-unit{min-height:84px;padding:13px 9px;border:1px solid #d4e5f8;border-radius:11px;background:#fff;text-align:center;display:flex;flex-direction:column;align-items:center;justify-content:center;color:#143b68;font-size:.82rem;font-weight:800;transition:transform .2s,box-shadow .2s}
.sol-ecom-b2b2c .arch-unit:hover{transform:translateY(-3px);box-shadow:0 7px 16px rgba(30,136,229,.12)}
.sol-ecom-b2b2c .arch-unit i{display:grid;place-items:center;width:24px;height:24px;margin-bottom:6px;border-radius:7px;background:#e5f1ff;color:#1565c0;font-size:.72rem;font-style:normal}
.sol-ecom-b2b2c .arch-unit small{display:block;color:#7088a3;font-size:.66rem;font-weight:400;line-height:1.35;margin-top:4px}
.sol-ecom-b2b2c .arch-band.core .arch-band-label{background:#0d47a1;color:#fff}
.sol-ecom-b2b2c .arch-band.core .arch-band-label small{color:#c6e1ff}
.sol-ecom-b2b2c .arch-band.core .arch-unit{background:#1565c0;border-color:#1565c0;color:#fff}
.sol-ecom-b2b2c .arch-band.core .arch-unit i{background:#fff;color:#1565c0}
.sol-ecom-b2b2c .arch-band.core .arch-unit small{color:#d6eaff}
.sol-ecom-b2b2c .arch-map-note{display:flex;align-items:center;justify-content:center;gap:9px;margin-top:20px;padding-top:16px;border-top:1px dashed #cfe1f6;color:#5f7b9c;font-size:.8rem}

/* ===== Core Functions ===== */
.sol-ecom-b2b2c .func-section{background:#f5f9ff}
.sol-ecom-b2b2c .func-section .section-head{max-width:740px;margin-left:auto;margin-right:auto}
.sol-ecom-b2b2c .func-grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:20px;align-items:stretch}
.sol-ecom-b2b2c .func-card{min-height:292px;padding:0;display:flex;position:relative;overflow:hidden;border:1px solid #d7e6f6;border-radius:16px;background:#fff;box-shadow:0 7px 18px rgba(18,74,136,.055);transition:transform .25s ease,box-shadow .25s ease,border-color .25s ease}
.sol-ecom-b2b2c .func-card:hover{transform:translateY(-7px);border-color:#78b7f4;box-shadow:0 16px 30px rgba(18,112,212,.14)}
.sol-ecom-b2b2c .func-card:before{content:"";display:block;position:absolute;left:0;top:0;bottom:0;width:4px;height:auto;background:#1e88e5}
.sol-ecom-b2b2c .func-card-num{position:absolute;top:18px;right:18px;width:34px;height:28px;display:grid;place-items:center;border-radius:8px;background:#e9f3ff;color:#1565c0;font-size:.72rem;font-weight:800;letter-spacing:.06em}
.sol-ecom-b2b2c .func-card-body{width:100%;display:flex;flex-direction:column;align-items:flex-start;padding:27px 24px 24px}
.sol-ecom-b2b2c .func-card-icon{width:48px;height:48px;display:grid;place-items:center;flex:none;border-radius:13px;background:#e7f2ff;color:#1565c0;box-shadow:none;margin:0 0 22px}
.sol-ecom-b2b2c .func-card-icon svg{width:24px;height:24px}
.sol-ecom-b2b2c .func-card h3{margin:0 0 11px;min-height:48px;display:flex;align-items:flex-start;font-size:1.03rem;line-height:1.45;color:#102e52}
.sol-ecom-b2b2c .func-card p{margin:0;font-size:.88rem;color:#476585;line-height:1.75}

/* ===== Core Advantages ===== */
.sol-ecom-b2b2c .advantage-section{background:#fff}
.sol-ecom-b2b2c .advantage-grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:18px}
.sol-ecom-b2b2c .advantage-card{background:#fff;border:1px solid var(--c-border);border-radius:var(--radius);padding:34px 28px;transition:all .3s;position:relative;overflow:hidden;min-height:238px}
.sol-ecom-b2b2c .advantage-card:hover{box-shadow:var(--shadow-lg);transform:translateY(-4px);border-color:var(--c-primary-light)}
.sol-ecom-b2b2c .advantage-card::before{content:"";position:absolute;bottom:0;left:0;right:0;height:3px;background:linear-gradient(90deg,#1e88e5,#42a5f5);transform:scaleX(0);transform-origin:left;transition:transform .4s}
.sol-ecom-b2b2c .advantage-card:hover::before{transform:scaleX(1)}
.sol-ecom-b2b2c .advantage-icon{width:48px;height:48px;border-radius:12px;background:#1e88e5;display:flex;align-items:center;justify-content:center;margin-bottom:20px;box-shadow:0 6px 16px rgba(30,136,229,.25)}
.sol-ecom-b2b2c .advantage-icon svg{width:24px;height:24px;color:#fff}
.sol-ecom-b2b2c .advantage-card h3{font-size:1.12rem;font-weight:700;color:var(--c-text);margin-bottom:12px}
.sol-ecom-b2b2c .advantage-card p{font-size:.9rem;color:var(--c-slate);line-height:1.75}

/* ===== Application Scenarios ===== */
.sol-ecom-b2b2c .scenario-section{background:#f5f9ff}
.sol-ecom-b2b2c .scenario-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:24px}
.sol-ecom-b2b2c .scenario-card{background:#fff;border:1px solid var(--c-border);border-radius:var(--radius);padding:32px 28px;transition:all .3s;position:relative;overflow:hidden}
.sol-ecom-b2b2c .scenario-card:hover{box-shadow:var(--shadow-lg);transform:translateY(-4px);border-color:var(--c-primary-light)}
.sol-ecom-b2b2c .scenario-tag{display:inline-block;padding:5px 12px;background:#e6f1ff;color:var(--c-primary);font-size:.72rem;font-weight:700;border-radius:100px;margin-bottom:16px}
.sol-ecom-b2b2c .scenario-card h3{font-size:1.1rem;font-weight:700;color:var(--c-text);margin-bottom:12px}
.sol-ecom-b2b2c .scenario-card p{font-size:.9rem;color:var(--c-slate);line-height:1.75}

/* ===== Customer Value ===== */
.sol-ecom-b2b2c .value-section{background:#fff}
.sol-ecom-b2b2c .value-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:22px}
.sol-ecom-b2b2c .value-card{background:#fff;border:1px solid var(--c-border);border-radius:var(--radius-lg);padding:36px 26px;text-align:center;transition:all .3s;position:relative;overflow:hidden}
.sol-ecom-b2b2c .value-card:hover{box-shadow:var(--shadow-lg);transform:translateY(-6px)}
.sol-ecom-b2b2c .value-card::before{content:"";position:absolute;top:0;left:0;right:0;height:4px;background:#1e88e5;transform:scaleX(0);transform-origin:center;transition:transform .4s}
.sol-ecom-b2b2c .value-card:hover::before{transform:scaleX(1)}
.sol-ecom-b2b2c .value-icon{width:56px;height:56px;border-radius:14px;background:#1e88e5;display:flex;align-items:center;justify-content:center;margin:0 auto 20px;box-shadow:0 8px 20px rgba(30,136,229,.3)}
.sol-ecom-b2b2c .value-icon svg{width:28px;height:28px;color:#fff}
.sol-ecom-b2b2c .value-card h3{font-size:1.1rem;font-weight:700;color:var(--c-text);margin-bottom:12px}
.sol-ecom-b2b2c .value-card p{font-size:.88rem;color:var(--c-slate);line-height:1.75}
.sol-ecom-b2b2c .value-highlight{display:inline-block;margin-top:14px;padding:5px 14px;background:#fff;border:1px solid var(--c-primary-light);border-radius:100px;font-size:.78rem;font-weight:700;color:var(--c-primary)}

/* ===== Trust Section ===== */
.sol-ecom-b2b2c .trust-section{background:#0d47a1;position:relative;overflow:hidden;padding:100px 0}
.sol-ecom-b2b2c .trust-section::after{content:"";position:absolute;bottom:0;left:0;right:0;height:1px;background:linear-gradient(90deg,transparent,rgba(255,255,255,.1),transparent)}
.sol-ecom-b2b2c .trust-section .section-title{color:#fff}
.sol-ecom-b2b2c .trust-section .section-subtitle{color:rgba(255,255,255,.7)}
.sol-ecom-b2b2c .trust-stats{display:grid;grid-template-columns:repeat(4,1fr);gap:24px;margin-bottom:60px}
.sol-ecom-b2b2c .trust-stat{text-align:center;padding:36px 22px;background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.1);border-radius:var(--radius);transition:.3s;backdrop-filter:blur(6px)}
.sol-ecom-b2b2c .trust-stat:hover{background:rgba(255,255,255,.08);border-color:rgba(255,255,255,.18);transform:translateY(-6px)}
.sol-ecom-b2b2c .trust-stat .num{font-size:2.8rem;font-weight:900;color:#fff;letter-spacing:-.025em;line-height:1;margin-bottom:8px}
.sol-ecom-b2b2c .trust-stat .num .unit{font-size:1.4rem;font-weight:700}
.sol-ecom-b2b2c .trust-stat .label{font-size:.88rem;color:rgba(255,255,255,.55);font-weight:500}
.sol-ecom-b2b2c .logo-wall{background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.1);border-radius:var(--radius-lg);padding:44px;margin-bottom:48px;backdrop-filter:blur(6px)}
.sol-ecom-b2b2c .logo-wall-title{text-align:center;font-size:.82rem;color:rgba(255,255,255,.45);letter-spacing:.18em;text-transform:uppercase;margin-bottom:28px;font-weight:600}
.sol-ecom-b2b2c .logo-grid{display:grid;grid-template-columns:repeat(6,1fr);gap:18px}
.sol-ecom-b2b2c .logo-item{height:64px;background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.08);border-radius:12px;display:flex;align-items:center;justify-content:center;font-size:.82rem;font-weight:700;color:rgba(255,255,255,.4);transition:.3s}
.sol-ecom-b2b2c .logo-item:hover{background:rgba(255,255,255,.08);color:rgba(255,255,255,.8);border-color:rgba(255,255,255,.18);transform:translateY(-2px)}
.sol-ecom-b2b2c .trust-cert{display:grid;grid-template-columns:repeat(3,1fr);gap:22px}
.sol-ecom-b2b2c .cert-card{background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.1);border-radius:var(--radius);padding:28px;display:flex;align-items:center;gap:18px;transition:.3s;backdrop-filter:blur(6px)}
.sol-ecom-b2b2c .cert-card:hover{background:rgba(255,255,255,.08);transform:translateY(-3px)}
.sol-ecom-b2b2c .cert-icon{width:52px;height:52px;border-radius:12px;background:linear-gradient(135deg,rgba(66,165,245,.2),rgba(30,136,229,.2));display:flex;align-items:center;justify-content:center;flex-shrink:0;border:1px solid rgba(66,165,245,.3)}
.sol-ecom-b2b2c .cert-icon svg{width:26px;height:26px;color:#90caf9}
.sol-ecom-b2b2c .cert-info .title{font-size:.92rem;font-weight:700;color:#fff;margin-bottom:4px}
.sol-ecom-b2b2c .cert-info .desc{font-size:.78rem;color:rgba(255,255,255,.45)}

/* ===== FAQ ===== */
.sol-ecom-b2b2c .faq-section{background:#f5f9ff}
.sol-ecom-b2b2c .faq-wrap{max-width:880px;margin:0 auto}
.sol-ecom-b2b2c .faq-item{border:1.5px solid var(--c-border);border-radius:var(--radius);margin-bottom:14px;overflow:hidden;transition:.3s;background:#fff}
.sol-ecom-b2b2c .faq-item.active{border-color:var(--c-primary);box-shadow:0 8px 28px rgba(30,136,229,.12)}
.sol-ecom-b2b2c .faq-item.active .faq-q{color:var(--c-primary)}
.sol-ecom-b2b2c .faq-q{display:flex;align-items:center;justify-content:space-between;padding:22px 28px;cursor:pointer;font-size:1rem;font-weight:600;color:var(--c-text);transition:color .2s;user-select:none;gap:16px}
.sol-ecom-b2b2c .faq-q .arrow{width:22px;height:22px;flex-shrink:0;transition:transform .3s;color:var(--c-slate-light)}
.sol-ecom-b2b2c .faq-item.active .faq-q .arrow{transform:rotate(180deg);color:var(--c-primary)}
.sol-ecom-b2b2c .faq-a{max-height:0;overflow:hidden;transition:max-height .4s ease}
.sol-ecom-b2b2c .faq-a-inner{padding:0 28px 24px;font-size:.94rem;color:var(--c-slate);line-height:1.85}

/* ===== Final CTA ===== */
.sol-ecom-b2b2c .cta-section{position:relative;background:#1565c0;padding:100px 0;overflow:hidden}.cta-section::after{content:"";position:absolute;bottom:-1px;left:0;right:0;height:60px;background:#0d47a1;pointer-events:none;z-index:0}
.sol-ecom-b2b2c .cta-inner{position:relative;z-index:1;text-align:center;max-width:820px;margin:0 auto}
.sol-ecom-b2b2c .cta-inner h2{font-size:2.5rem;font-weight:900;color:#fff;letter-spacing:-.025em;margin-bottom:20px;line-height:1.25}
.sol-ecom-b2b2c .cta-inner h2 .highlight{color:#bbdefb}
.sol-ecom-b2b2c .cta-inner p{font-size:1.12rem;color:rgba(255,255,255,.8);line-height:1.85;margin-bottom:44px}
.sol-ecom-b2b2c .cta-options{display:flex;gap:18px;justify-content:center;flex-wrap:wrap;margin-bottom:36px}
.sol-ecom-b2b2c .cta-note{display:flex;align-items:center;justify-content:center;gap:10px;font-size:.85rem;color:rgba(255,255,255,.5);flex-wrap:wrap}
.sol-ecom-b2b2c .cta-note .dot{width:5px;height:5px;background:rgba(255,255,255,.3);border-radius:50%}

/* ===== Footer (zjssoft.com exact style) ===== */

/* ===== Scroll Animations ===== */
.sol-ecom-b2b2c .reveal{opacity:0;transform:translateY(32px);transition:opacity .8s ease,transform .8s ease}
.sol-ecom-b2b2c .reveal.active{opacity:1;transform:translateY(0)}
.sol-ecom-b2b2c .reveal-delay-1{transition-delay:.12s}
.sol-ecom-b2b2c .reveal-delay-2{transition-delay:.24s}
.sol-ecom-b2b2c .reveal-delay-3{transition-delay:.36s}

/* ===== Mobile Responsive ===== */
@media(max-width:1024px){
  .sol-ecom-b2b2c .hero-grid{grid-template-columns:1fr;gap:48px}
  .sol-ecom-b2b2c .hero h1{font-size:2.6rem}
  .sol-ecom-b2b2c .pain-grid{grid-template-columns:repeat(2,1fr)}
  .sol-ecom-b2b2c .solution-grid{grid-template-columns:1fr}
  .sol-ecom-b2b2c .route-track{grid-template-columns:repeat(2,1fr)}
  .sol-ecom-b2b2c .route-item:not(:last-child):after{display:none}
  .sol-ecom-b2b2c .arch-band{grid-template-columns:1fr}
  .sol-ecom-b2b2c .arch-band-content{grid-template-columns:repeat(3,1fr)}
  .sol-ecom-b2b2c .func-grid{grid-template-columns:repeat(2,1fr)}
  .sol-ecom-b2b2c .advantage-grid{grid-template-columns:repeat(2,1fr)}
  .sol-ecom-b2b2c .scenario-grid{grid-template-columns:repeat(2,1fr)}
  .sol-ecom-b2b2c .value-grid{grid-template-columns:repeat(2,1fr)}
  .sol-ecom-b2b2c .trust-stats{grid-template-columns:repeat(2,1fr)}
  .sol-ecom-b2b2c .logo-grid{grid-template-columns:repeat(3,1fr)}
  .sol-ecom-b2b2c .trust-cert{grid-template-columns:1fr}
}
@media(max-width:768px){
  .sol-ecom-b2b2c .section{padding:72px 0}
  .sol-ecom-b2b2c .section-title{font-size:1.8rem}
  .sol-ecom-b2b2c .section-head{margin-bottom:42px}
  .sol-ecom-b2b2c .hero{padding:100px 0 64px}
  .sol-ecom-b2b2c .hero h1{font-size:2.1rem}
  .sol-ecom-b2b2c .hero-sub{font-size:1.05rem}
  .sol-ecom-b2b2c .hero-cta{flex-direction:column;width:100%}
  .sol-ecom-b2b2c .hero-cta .btn{width:100%}
  .sol-ecom-b2b2c .hero-trust{gap:20px}
  .sol-ecom-b2b2c .hero-trust-divider{display:none}
  .sol-ecom-b2b2c .hero-trust-num{font-size:1.4rem}
  .sol-ecom-b2b2c .hero-trust-label{font-size:.78rem}
  .sol-ecom-b2b2c .hero-visual{max-width:440px;margin:0 auto}
  .sol-ecom-b2b2c .dash-float{display:none}
  .sol-ecom-b2b2c .pain-grid{grid-template-columns:1fr;gap:18px}
  .sol-ecom-b2b2c .pain-card{padding:30px 24px}
  .sol-ecom-b2b2c .route-track{grid-template-columns:1fr}
  .sol-ecom-b2b2c .arch-band-content{grid-template-columns:repeat(2,1fr)}
  .sol-ecom-b2b2c .func-card{min-height:auto;padding:0;flex-direction:column;gap:16px}
  .sol-ecom-b2b2c .func-card h3{min-height:auto}
  .sol-ecom-b2b2c .advantage-grid{grid-template-columns:1fr}
  .sol-ecom-b2b2c .scenario-grid{grid-template-columns:1fr}
  .sol-ecom-b2b2c .value-grid{grid-template-columns:1fr 1fr}
  .sol-ecom-b2b2c .trust-stats{grid-template-columns:1fr 1fr;gap:14px}
  .sol-ecom-b2b2c .trust-stat{padding:24px 14px}
  .sol-ecom-b2b2c .trust-stat .num{font-size:2.1rem}
  .sol-ecom-b2b2c .logo-wall{padding:28px}
  .sol-ecom-b2b2c .logo-grid{grid-template-columns:repeat(2,1fr);gap:14px}
  .sol-ecom-b2b2c .logo-item{height:54px;font-size:.75rem}
  .sol-ecom-b2b2c .cert-card{padding:20px}
  .sol-ecom-b2b2c .cta-inner h2{font-size:1.9rem}
  .sol-ecom-b2b2c .cta-inner p{font-size:1rem}
  .sol-ecom-b2b2c .cta-options{flex-direction:column;width:100%}
  .sol-ecom-b2b2c .cta-options .btn{width:100%}
}
@media(max-width:480px){
  .sol-ecom-b2b2c .container{padding:0 18px}
  .sol-ecom-b2b2c .hero h1{font-size:1.85rem}
  .sol-ecom-b2b2c .section-title{font-size:1.55rem}
  .sol-ecom-b2b2c .dash-stats{grid-template-columns:1fr;gap:8px}
  .sol-ecom-b2b2c .value-grid{grid-template-columns:1fr}
}

@media(max-width:1024px){
  
}
@media(max-width:768px){
  .sol-ecom-b2b2c .hero-trust{justify-content:flex-start}
  .sol-ecom-b2b2c .hero-trust-item{min-width:80px}
  .sol-ecom-b2b2c .arch-band-content{grid-template-columns:repeat(2,1fr)}
  .sol-ecom-b2b2c .arch-unit{min-height:72px}
  .sol-ecom-b2b2c .route-track{grid-template-columns:1fr}
  .sol-ecom-b2b2c .route-item:not(:last-child):after{display:none}
}
@media(max-width:480px){
  .sol-ecom-b2b2c .hero-trust{gap:14px}
  .sol-ecom-b2b2c .hero-trust-item{min-width:68px}
  .sol-ecom-b2b2c .hero-trust-num{font-size:1.25rem}
  .sol-ecom-b2b2c .hero-trust-label{font-size:.72rem}
  .sol-ecom-b2b2c .arch-band-content{grid-template-columns:repeat(2,1fr);gap:8px}
  .sol-ecom-b2b2c .arch-unit{padding:10px 6px;font-size:.72rem}
  .sol-ecom-b2b2c .arch-unit i{width:20px;height:20px;font-size:.65rem}
  .sol-ecom-b2b2c .arch-unit small{display:none}
  .sol-ecom-b2b2c .faq-q{padding:18px 20px;font-size:.94rem}
  .sol-ecom-b2b2c .faq-a-inner{padding:0 20px 20px;font-size:.9rem}
}
</style>
